import type { ReactNode } from "react";
import { typedMemo } from "src/types/typedMemo";
import type {
  CarouselId,
  CarouselItemType,
} from "src/website-apps/shared/components/carousel-module/carousel-analytics-event";
import { parentContainer, titleContent, titleRow } from "./performer-carousel.recipe";
import { PerformerCarousel } from "./PerformerCarousel";

export interface PerformerCarouselModuleProps<T> {
  items: readonly T[];
  renderItem: (item: T, index: number, onItemClick: (itemId: string | number) => void) => ReactNode;
  getItemKey: (item: T) => string | number;
  header: ReactNode;
  carouselId: CarouselId;
  /** The type of items in this carousel. Use `CarouselItemType` for valid values. */
  itemType?: CarouselItemType | undefined;
}

/**
 * Generic carousel module for performer pages.
 */
const PerformerCarouselModuleComponent = <T,>({
  items,
  renderItem,
  getItemKey,
  header,
  carouselId,
  itemType,
}: PerformerCarouselModuleProps<T>) => {
  return (
    <div className={parentContainer}>
      <div className={titleRow}>
        <div className={titleContent}>{header}</div>
      </div>
      <PerformerCarousel<T>
        items={items}
        renderItem={renderItem}
        getItemKey={getItemKey}
        carouselId={carouselId}
        itemType={itemType}
      />
    </div>
  );
};

export const PerformerCarouselModule = typedMemo(PerformerCarouselModuleComponent);
